import createPlayer from '../shared/utils/create-player.js';

/**
 * handles all interactions with the about us section
 * @return {undefined}
 */
export default function aboutUsSection() {
  const playButtons = $('.about-us-section--video-button');
  let isOpen = false;

  if (playButtons) {
    playButtons.each((idx, playButton) => {
      /**
       * Create a pop over to view the video in
       */
      $(playButton).on('click', () => {
        if (isOpen) return;

        isOpen = true;

        const closeButton = Object.assign(document.createElement('button'), {
          className: 'sl-about-us-player__close',
          innerHTML: 'x'
        });
        const wrapperDiv = Object.assign(document.createElement('div'), {
          className: 'sl-about-us-player --gutter'
        });
        const div = Object.assign(document.createElement('div'), {
          className: 'sl-about-us-player__yt'
        });

        const id = $(playButton).data('id');
        const opions = {
          autoplay: true
        };

        // Append node to body
        document.body.append(wrapperDiv);
        wrapperDiv.append(closeButton);
        wrapperDiv.append(div);

        // Create player and register close button
        createPlayer(div, id, opions).then((player) => {
          document
            .querySelector('.sl-about-us-player__close')
            .addEventListener('click', () => {
              player.destroy();
              wrapperDiv.remove();
              isOpen = false;
            });
        });
      });
    });
  }
}
